import { isLocalPreview } from './localPreview';
import { isInsideTelegram } from './telegram';

export const MINI_APP_PREVIEW_SURFACE_KEY = 'dev:previewSurface';

/** UI layout only: this preference never changes Telegram detection or credentials. */
export function isMiniAppLayout(): boolean {
  if (isInsideTelegram()) return true;
  if (!isLocalPreview()) return false;

  try {
    return localStorage.getItem(MINI_APP_PREVIEW_SURFACE_KEY) === 'telegram';
  } catch {
    // Browsers can block storage; the normal website remains usable.
    return false;
  }
}
